export const actionTypes = {
    SET_SETTINGS: 'SET_SETTINGS'
};

export const setSettings = (payload:any) => ({
    type: actionTypes.SET_SETTINGS,
    payload,
});

